export const ACCOUNT_CATEGORIES = [
  { id: 'investments', label: 'Investments' },
  { id: 'crypto', label: 'Crypto' },
  { id: 'deposit', label: 'Deposit' },
  { id: 'cash', label: 'Cash' },
]

export const ACCOUNT_SOURCES = [
  { id: 'manual', label: 'Manual' },
  { id: 'coinbase', label: 'Coinbase (synced)' },
  { id: 'lightyear', label: 'Lightyear (CSV)' },
]

export const INCOME_CATEGORIES = ['Salary', 'Work', 'Gift', 'Sale', 'Interest', 'Other']
export const EXPENSE_CATEGORIES = [
  'Housing', 'Utilities', 'Loan', 'Subscriptions', 'Groceries', 'Eating out',
  'Transport', 'Shopping', 'Health', 'Entertainment', 'Travel', 'Other',
]

export const DEFAULT_SETTINGS = { currency: 'EUR', locale: 'hu-HU' }
